export const WorkoutPageState = {
    Create: 'create',
    Edit: 'edit',
    Readonly: 'readonly',
    Saved: 'saved', // this shows the "Done" button in the header and certain banners
    Viewonly: 'viewonly'
};

export const HeaderButtons = {
    Edit: 'edit',
    SendToDevice: 'sendToDevice',
    Cancel: 'cancel',
    Done: 'done',
    Save: 'save',
    SaveProviderWorkout: 'saveProviderWorkout'
};

export const NotificationTypes = {
    NoAlert: 'NO_ALERT',
    CopyError: 'COPY_ERROR',
    CopySuccess: 'COPY_SUCCESS',
    Saved: 'SAVED',
    SaveError: 'SAVE_ERROR',
    NameUpdated: 'NAME_UPDATED',
    EmptyRepeat: 'EMPTY_REPEAT',
    ExceedMaxSteps: 'EXCEED_MAX_STEPS',
    NearMaxSteps: 'NEAR_MAX_STEPS',
    RepeatTooDeep: 'REPEAT_TOO_DEEP',
    Scheduled: 'SCHEDULED',
    ScheduleError: 'SCHEDULE_ERROR'
};

export const ExecutableStepDTOType = 'ExecutableStepDTO';
export const RepeatGroupDTOType = 'RepeatGroupDTO';

export const EstimateType = {
    Time: 'TIME_ESTIMATED',
    Distance: 'DISTANCE_ESTIMATED',
    TimeAndDistance: 'TIME_AND_DISTANCE_ESTIMATED'
};

export const SportTypes = {
    Running: 'running',
    Cycling: 'cycling',
    Other: 'other',
    Swimming: 'swimming',
    Strength_Training: 'strength_training',
    Cardio: 'cardio_training',
    Yoga: 'yoga',
    Pilates: 'pilates',
    Hiit: 'hiit',
    Multisport: 'multi_sport',
    Mobility: 'mobility'
};

export const HiitSubSportTypes = {
    TABATA: 'TABATA',
    EMOM: 'EMOM',
    AMRAP: 'AMRAP',
    GENERIC: 'GENERIC'
};

export const DialogActionTypes = {
    CANCEL: 'CANCEL',
    CONFIRM: 'CONFIRM'
};

export const AudioNoteRetryType = {
    Upload: 'upload',
    Download: 'download'
};

export const NO_EXERCISE_CHOSEN = 'no_exercise_chosen';
export const CHOOSE_AN_EXERCISE = 'choose_an_exercise';

export const LEGACY_MAX_STEPS = 50;

export const POOL_SWIM_PARTIAL_SUPPORT_URL =
    'https://support.garmin.com/sas/gcapp/?productId=125677&contentId=fXDWMUWcuw5ACMmLqjjC59';

export const EditWorkoutButtonType = {
    ADD_STEP: 'addStep',
    ADD_REPEAT_STEP: 'addRepeatStep',
    SAVE: 'save'
};
export const WorkoutLegAndStepLimit = {
    LegMax: 25,
    LegClose: 20,
    TotalStepMax: 250,
    TotalStepClose: 225
};
export const LegStepLimitNotificationString = {
    reachLegLimit: 'workout:workout.multi.sport.alert.reach.limit.leg',
    closeLegLimit: 'workout:workout.multi.sport.alert.close.to.limit.leg',
    reachTotalStepLimit: 'workout:workout.multi.sport.alert.reach.limit.step',
    closeTotalStepLimit: 'workout:workout.multi.sport.alert.close.to.limit.step',
    reachLegStepLimit: 'workout:workout.multi.sport.alert.reach.limit.leg.step',
    closeLegStepLimit: 'workout:workout.multi.sport.alert.close.to.limit.leg.step',
    reachStepLimit: 'workout:workout.multi.sport.alert.reach.sport.limit',
    closeStepLimit: 'workout:workout.multi.sport.alert.close.to.sport.limit',
    closeTotalStepAndLegStepLimit: 'workout:workout.multi.sport.alert.close.to.sport.and.total.limit',
    noAlert: ''
};
export const LimitStatus = {
    NoAlert: 'noAlert',
    Reached: 'reached',
    Closed: 'closed'
};
